import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import Memo from "../../memo";

export const MemoFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => {
  const autoGrow = campo.extraProps?.autoGrow === true;
  const altura = campo.extraProps?.altura ?? (autoGrow ? "60px" : "120px");
  return (
    <>
      <Memo
        campo={campo}
        modo={modo}
        getFieldValue={getFieldValue}
        handleInputChange={handleInputChange}
        onCampoEntrar={campo.onCampoEntrar}
        tudoMaiusculo={campo.tudoMaiusculo}
        apenasLeitura={campo.apenasLeitura || false}
        altura={altura}
        autoGrow={autoGrow}
        maxLength={campo.maximoCaracteres}
        onBlur={(c: any) => handleBlur(c)}
        hasError={!!errors[campo.nome]}
      />
      {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
    </>
  );
};
